// Converts the given alignment value into a full classname string for use with tailwind.
export default function getTextAlignClassName(alignmentValue, defaultValue = "text-left") {
    const classMap = {
        center: "text-center",
        right: "text-right",
        left: "text-left",
    };
    return classMap[String(alignmentValue).toLowerCase()] ?? defaultValue;
}
